import React from "react";

/**
 * What the Performance tab says when the selected period has no answer (P2).
 *
 * "Gesamte Zeit" is unbounded, and an unbounded operating margin has no
 * denominator — there is no period to divide by. The contract therefore bounds a
 * window at 24 months and offers no all-time form.
 *
 * WHY THIS IS A STATE AND NOT A FALLBACK
 * --------------------------------------
 * The tab used to answer an unanswerable period with the range's TO-month, which
 * is how a filter reading "April – September 2026" came to show September's
 * figures. Quietly substituting "the last 24 months" would be the same mistake
 * with a longer window: a figure on screen that the label above it does not name.
 * Saying so costs the reader one sentence and costs them nothing they could have
 * trusted.
 *
 * Its own component because the tab is an orchestrator: a panel inlined "just
 * this once" is exactly the regression `performanceGuards` G7 pins the file size
 * against.
 */
export default function PerformanceUnsupportedPeriod() {
  return (
    <section data-testid="company-performance-tab" className="space-y-2">
      <header className="mb-4">
        <h1 className="m-0 text-[15px] font-semibold text-foreground">Performance</h1>
      </header>
      <p
        data-testid="performance-period-unsupported"
        className="rounded-xl border border-border bg-card px-3 py-2 text-[12px] text-muted-foreground"
      >
        Performance ist für ausgewählte Zeiträume bis 24 Monate verfügbar. Bitte
        wähle einen Zeitraum.
      </p>
    </section>
  );
}
